export default "__VITE_ASSET__DCLhXa_I__"